// extracted by mini-css-extract-plugin
module.exports = {"switch":"toggle_switch__Lj0xg","slider":"toggle_slider__1koPj"};